import React from 'react'
import { connect } from 'react-redux'

class Share extends React.Component {
	static defaultProps = {
		type: 'facebook',
		url: window.location.href,
		title: ''
	}

	constructor( props ) {
		super( props )

		this.handleClick = this.handleClick.bind( this )
	}

	handleClick( e ) {
		const href = e.currentTarget.getAttribute( 'href' )
		const w = 500
		const h = 550
		const left = ( screen.width / 2 ) - ( w / 2 )
		const top = ( screen.height / 2 ) - ( h / 2 )

		window.open(
			href,
			'shareWindow',
			'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
		)

		e.preventDefault()
	}

	render() {
		const { children, url, title, type } = this.props
		let shareUrl,
			content = url

		if ( title ) {
			content = `${title} ${url}`
		}

		switch ( type ) {
			case 'facebook':
				shareUrl = 'https://www.facebook.com/sharer.php?u=' + url
				break

			case 'twitter':
				shareUrl = 'https://twitter.com/home?status=' + content
				break

			case 'google-plus':
				shareUrl = 'https://plus.google.com/u/0/share?url=' + url
				break

			case 'email':
				shareUrl = 'mailto:?body=' + content
				break

			case 'fb-messenger':
				shareUrl = 'fb-messenger://share?link=' + url
				break

			case 'whatsapp':
				shareUrl = 'whatsapp://send?text=' + content
				break
		}

		return (
			<a href={ shareUrl } onClick={ this.handleClick }>
				{ children }
			</a>
		)
	}
}

export default Share
